/**
 * IvCert
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';
import { Observable } from 'rxjs';
import { IvGenericRestResponseListCircuitDocumentP } from '../model/ivGenericRestResponseListCircuitDocumentP';
import { IvGenericRestResponseListIvCertCircuitDocumentP } from '../model/ivGenericRestResponseListIvCertCircuitDocumentP';
import { BASE_PATH } from '../variables';
import { Configuration } from '../configuration';
import { DateParser } from "../date";
import { PersonalizationsService } from '../../base/services/personalizations/personalizations.service';
import { Environment } from '../../models/environment';
import { IvCertGenericResponseFileToPdfData } from '../model/ivCertGenericResponseFileToPdfData';
import { IvCertSendFileToPdfService } from '../model/ivCertSendFileToPdfService';
import { ConfirmDocumentDto } from '../model/confirmDocumentDto';
import { IvCertGenericResponseConfirmedDocumentsDto } from '../model/ivCertGenericResponseConfirmedDocumentsDto';
import { EnvironmentService } from './environment.service';

@Injectable()
export class DocumentService {

    environment: Environment;
    protected basePath: string;
    protected apiVersion: string;
    public defaultHeaders = new HttpHeaders().set('timeClient', DateParser.parse(new Date()));
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration, private _personalization: PersonalizationsService, private _env: EnvironmentService) {
        this.environment = this._personalization.sendEnv;
        this.apiVersion = this._env.apiVersion;
        this.basePath = this.environment?.url_api;
        this.defaultHeaders = this.defaultHeaders.set('X-Request-ID', 'app-front');
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
         *
         *
         * @param idCircuit
         * @param idDocument
         * @param authorization The authorization token
         * @param appId
         * @param idOperation
         * @param isThumbnail
         * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
         * @param reportProgress flag to report request and response progress.
         */
    async documentGetDownloadDocumentCircuit(idCircuit: string, idDocument: string, authorization: string, appId?: string, idOperation?: string, isThumbnail?: boolean, observe?: 'body', reportProgress?: boolean): Promise<any>;
    async documentGetDownloadDocumentCircuit(idCircuit: string, idDocument: string, authorization: string, appId?: string, idOperation?: string, isThumbnail?: boolean, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<any>>;
    async documentGetDownloadDocumentCircuit(idCircuit: string, idDocument: string, authorization: string, appId?: string, idOperation?: string, isThumbnail?: boolean, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<any>>;
    async documentGetDownloadDocumentCircuit(idCircuit: string, idDocument: string, authorization: string, appId?: string, idOperation?: string, isThumbnail?: boolean, observe: any = 'body', reportProgress: boolean = false): Promise<any> {

        if (idCircuit === null || idCircuit === undefined) {
            throw new Error('Required parameter idCircuit was null or undefined when calling documentGetDownloadDocumentCircuit.');
        }

        if (idDocument === null || idDocument === undefined) {
            throw new Error('Required parameter idDocument was null or undefined when calling documentGetDownloadDocumentCircuit.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling documentGetDownloadDocumentCircuit.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idCircuit !== undefined && idCircuit !== null) {
            queryParameters = queryParameters.set('idCircuit', <any>idCircuit);
        }
        if (idDocument !== undefined && idDocument !== null) {
            queryParameters = queryParameters.set('idDocument', <any>idDocument);
        }
        if (appId !== undefined && appId !== null) {
            queryParameters = queryParameters.set('appId', <any>appId);
        }
        if (idOperation !== undefined && idOperation !== null) {
            queryParameters = queryParameters.set('idOperation', <any>idOperation);
        }
        if (isThumbnail !== undefined && isThumbnail !== null) {
            queryParameters = queryParameters.set('isThumbnail', <any>isThumbnail);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return await this.httpClient.get(`${this.basePath}/api/${this.apiVersion}/Document/DownloadDocumentCircuit`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
                responseType: 'blob'
            }
        ).toPromise();
    }

    /**
     * Recupera el listado de documentos para un circuito
     *
     * @param authorization The authorization token
     * @param idCircuit
     * @param externalIdCircuit
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public documentGetListDocumentsCircuit(authorization: string, idCircuit?: string, externalIdCircuit?: string, observe?: 'body', reportProgress?: boolean): Observable<IvGenericRestResponseListCircuitDocumentP>;
    public documentGetListDocumentsCircuit(authorization: string, idCircuit?: string, externalIdCircuit?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvGenericRestResponseListCircuitDocumentP>>;
    public documentGetListDocumentsCircuit(authorization: string, idCircuit?: string, externalIdCircuit?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvGenericRestResponseListCircuitDocumentP>>;
    public documentGetListDocumentsCircuit(authorization: string, idCircuit?: string, externalIdCircuit?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling documentGetListDocumentsCircuit.');
        }



        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idCircuit !== undefined && idCircuit !== null) {
            queryParameters = queryParameters.set('idCircuit', <any>idCircuit);
        }
        if (externalIdCircuit !== undefined && externalIdCircuit !== null) {
            queryParameters = queryParameters.set('externalIdCircuit', <any>externalIdCircuit);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get(`${this.basePath}/api/${this.apiVersion}/Document/ListDocumentsCircuit`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param idOperation
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public documentGetDownloadDocumentsOperation(idOperation: string, authorization: string, documentType?: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public documentGetDownloadDocumentsOperation(idOperation: string, authorization: string, documentType?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public documentGetDownloadDocumentsOperation(idOperation: string, authorization: string, documentType?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public documentGetDownloadDocumentsOperation(idOperation: string, authorization: string, documentType?: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idOperation === null || idOperation === undefined) {
            throw new Error('Required parameter idOperation was null or undefined when calling documentGetDownloadDocumentsOperation.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling documentGetDownloadDocumentsOperation.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idOperation !== undefined && idOperation !== null) {
            queryParameters = queryParameters.set('idOperation', <any>idOperation);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        if (documentType !== undefined && documentType !== null) {
            queryParameters = queryParameters.set('documentType', <any>documentType);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get(`${this.basePath}/api/${this.apiVersion}/Document/DownloadDocumentsOperation`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
                responseType: 'blob'
            }
        );
    }

    /**
     * Recupera el listado de documentos para un circuito
     *
     * @param idOperation
     * @param authorization The authorization token
     * @param appId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    async documentGetListDocumentsOperation(idOperation: string, authorization: string, appId?: string, signerGuid?: string, observe?: 'body', reportProgress?: boolean): Promise<IvGenericRestResponseListIvCertCircuitDocumentP>;
    async documentGetListDocumentsOperation(idOperation: string, authorization: string, appId?: string, signerGuid?: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<IvGenericRestResponseListIvCertCircuitDocumentP>>;
    async documentGetListDocumentsOperation(idOperation: string, authorization: string, appId?: string, signerGuid?: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<IvGenericRestResponseListIvCertCircuitDocumentP>>;
    async documentGetListDocumentsOperation(idOperation: string, authorization: string, appId?: string, signerGuid?: string, observe: any = 'body', reportProgress: boolean = false): Promise<any> {

        if (idOperation === null || idOperation === undefined) {
            throw new Error('Required parameter idOperation was null or undefined when calling documentGetListDocumentsOperation.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling documentGetListDocumentsOperation.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idOperation !== undefined && idOperation !== null) {
            queryParameters = queryParameters.set('idOperation', <any>idOperation);
        }
        if (appId !== undefined && appId !== null) {
            queryParameters = queryParameters.set('appId', <any>appId);
        }
        if (signerGuid !== undefined && signerGuid !== null) {
            queryParameters = queryParameters.set('signerGuid', <any>signerGuid);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return await this.httpClient.get<IvGenericRestResponseListIvCertCircuitDocumentP>(`${this.basePath}/api/${this.apiVersion}/Document/ListDocumentsOperation`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * Validar documento a través de su CSV
     *
     * @param csv CSV del documento
     * @param authorization The authorization token
     * @param appId Identificador de la personalización
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public documentGetValidateCSV(csv: string, authorization: string, appId?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public documentGetValidateCSV(csv: string, authorization: string, appId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public documentGetValidateCSV(csv: string, authorization: string, appId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public documentGetValidateCSV(csv: string, authorization: string, appId?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (csv === null || csv === undefined) {
            throw new Error('Required parameter csv was null or undefined when calling documentGetValidateCSV.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling documentGetValidateCSV.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (csv !== undefined && csv !== null) {
            queryParameters = queryParameters.set('csv', <any>csv);
        }
        if (appId !== undefined && appId !== null) {
            queryParameters = queryParameters.set('appId', <any>appId);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
            headers = headers.set("filename", httpHeaderAcceptSelected);
        }

        return this.httpClient.get(`${this.basePath}/api/${this.apiVersion}/Document/ValidateCSV`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
                responseType: 'blob' as 'json'
            }
        );
    }

    /**
    *
    *
    * @param sendFile
    * @param authorization The authorization token
    * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
    * @param reportProgress flag to report request and response progress.
    */
    public documentPostConvertDocumentToPdf(sendFile: IvCertSendFileToPdfService, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseFileToPdfData>;
    public documentPostConvertDocumentToPdf(sendFile: IvCertSendFileToPdfService, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseFileToPdfData>>;
    public documentPostConvertDocumentToPdf(sendFile: IvCertSendFileToPdfService, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseFileToPdfData>>;
    public documentPostConvertDocumentToPdf(sendFile: IvCertSendFileToPdfService, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (sendFile === null || sendFile === undefined) {
            throw new Error('Required parameter sendFile was null or undefined when calling documentPostConvertDocumentToPdf.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling documentPostConvertDocumentToPdf.');
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<IvCertGenericResponseFileToPdfData>(`${this.basePath}/api/${this.apiVersion}/Document/ConvertDocumentToPdf`,
            sendFile,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param input
     * @param Authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public documentPostConfirmDocument(input: ConfirmDocumentDto, Authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseConfirmedDocumentsDto>;
    public documentPostConfirmDocument(input: ConfirmDocumentDto, Authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseConfirmedDocumentsDto>>;
    public documentPostConfirmDocument(input: ConfirmDocumentDto, Authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseConfirmedDocumentsDto>>;
    public documentPostConfirmDocument(input: ConfirmDocumentDto, Authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (input === null || input === undefined) {
            throw new Error('Required parameter input was null or undefined when calling documentPostConfirmDocument.');
        }

        if (Authorization === null || Authorization === undefined) {
            throw new Error('Required parameter Authorization was null or undefined when calling documentPostConfirmDocument.');
        }

        let headers = this.defaultHeaders;
        if (Authorization !== undefined && Authorization !== null) {
            headers = headers.set('Authorization', String(Authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<IvCertGenericResponseConfirmedDocumentsDto>(`${this.basePath}/api/${this.apiVersion}/Document/Confirm`,
            input,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }
}
